import { render, staticRenderFns } from "./LayerLegendComponent.vue.js?vue&type=template&id=5ef8a912&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=template&id=5ef8a912&scoped=true"
import script from "./LayerLegendComponent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=script&lang=js"
export * from "./LayerLegendComponent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerLegendComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef8a912",
  null
  
)

export default component.exports